import { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

import Swal from 'sweetalert2';

import { MdOutlineLanguage } from "react-icons/md";

export default function LanguageButton() {    
    
    const idiomas = {
        es: "Español",
        en: "English"
    }
    const refBtn = useRef()
    const { t, i18n } = useTranslation();
    const location = useLocation()
    const [hide, setHide] = useState(false);
    
    
    
    useEffect(() => {
        const elements = []
        const videos = Array.from(document.querySelectorAll("video"))
        elements.push(...videos)        

        const checkOverlap = () => {
            const isOverlapping  = elements.some(element => overlap(refBtn.current,element))
            setHide(isOverlapping)
            
        }
        window.addEventListener("scroll",checkOverlap)
        window.addEventListener("resize",checkOverlap)
        checkOverlap()
        
        return () => {
            window.removeEventListener("scroll",checkOverlap)
            window.removeEventListener("resize",checkOverlap)            
        }
    }, [location.pathname]);

    const cambiarIdiomaV2 = () => {
        const currentLanguagee = i18n.resolvedLanguage

        function createRadios(){
            let html = ''
            for(const i in idiomas){
                html += `
                <div class="form-check">
                    <input class="form-check-input" type="radio" lan-value="${i}" name="swal-language" id="language-${i}" ${i===currentLanguagee?"checked":""}>
                    <label class="form-check-label" for="language-${i}">
                        ${idiomas[i]}
                    </label>
                </div>
                `
            }
            return html
        }

        Swal.fire({
            title: t("idiomas_swal_title"),
            html:`
            <div class='container d-flex justify-content-center'>
                <div class='language-selector-input'>
                    ${createRadios()}
                </div>
            </div>
            `,
            confirmButtonText: t("idiomas_swal_confirm"),
            confirmButtonColor: 'rgb(5, 47, 62)',
            showCloseButton:true,
            preConfirm:()=>{
                const checked = document.querySelector('input[name="swal-language"]:checked')
                if(! checked){
                    Swal.showValidationMessage(t("idiomas_swal_warning"))
                    return
                }                
                return checked.getAttribute("lan-value")
            }
        }).then(result=>{
            if(result.isConfirmed){
                i18n.changeLanguage(result.value)
            }
        })
    }
    
    return (
        <div ref={refBtn} className={`btn-language ${hide?"hide":""}`} onClick={cambiarIdiomaV2} style={{"--custom-language":`"${idiomas[i18n.resolvedLanguage]}"`}}>
            <MdOutlineLanguage/>
        </div>
    )    
}

function overlap(a, b) {
  const r1 = a.getBoundingClientRect();
  const r2 = b.getBoundingClientRect();
    
  return !(
    r1.right < r2.left ||
    r1.left > r2.right ||
    r1.bottom < r2.top ||
    r1.top > r2.bottom
  );
}